import * as Yup from 'yup';
import { RequiredBooleanSchema } from 'yup/lib/boolean';
import { OptionalObjectSchema } from 'yup/lib/object';
import { Property } from 'models/Properties';

export const assistPropertiesSelectSchema = (properties: Property[]) => ({
  properties: Yup.object(
    properties.reduce(
      (shape, { uid }) => ({ ...shape, [uid]: Yup.boolean().required() }),
      {} as Record<string, RequiredBooleanSchema<boolean | undefined>>,
    ),
  ).required(),
});

export type AssistPropertiesSelectFormValues = Yup.InferType<
  OptionalObjectSchema<ReturnType<typeof assistPropertiesSelectSchema>>
>;

export const getFormDefaultValues = ({
  properties,
  selectedProperties,
}: {
  properties: Property[];
  selectedProperties: string[];
}): AssistPropertiesSelectFormValues => ({
  properties: properties.reduce(
    (acc, { uid }) => ({ ...acc, [uid]: selectedProperties.includes(uid) }),
    {} as Record<string, boolean>,
  ),
});
